/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {fetch} from '@adobe/exc-app/network';
import {WorkHubResponse} from '../models/WorkHub';

export async function getWorkHubResponse(ioGateway: string, sessionId: string, product: string, locale = 'en_US'): Promise<WorkHubResponse[] | void> {
  const url = `${ioGateway}/navigation/v1/capabilities?product=${product}&locale=${locale}`;
  if (!sessionId) {
    return;
  }
  const response = await fetch(url, {
    auth: 'Header',
    excludeSandboxType: true,
    headers: {
      'Content-Type': 'application/json',
      'ims-sessionid': sessionId,
      'x-sandbox-name': 'none'
    },
    method: 'GET'
  });
  try {
    if (response.ok) {
      return response.json();
    }
  } catch (error) {
    return;
  }
}
